import { inject, Injectable } from '@angular/core';
import { BaseService } from '@shared/core';
import { map, Observable } from 'rxjs';
import { IBaseFilterParams, IParkingLotItem, IParkingLotsResponseModel } from '@pkp-g/core';

@Injectable({
  providedIn: 'root',
})
export class ParkingLotsService {
  private http = inject(BaseService);
  apiUrl = 'v1/parking-lots';

  getAllParkingLots(filter?: IBaseFilterParams): Observable<IParkingLotsResponseModel> {
    return this.http.getWithHeaders(this.apiUrl, filter).pipe(
      map(res => ({
        items: res.body ?? [],
        total: Number(res.headers.get('X-Pagination-Total') ?? 0),
      })),
    );
  }

  setParkingLot(payload: IParkingLotItem): Observable<string> {
    return this.http.post(this.apiUrl, payload);
  }

  getParkingLotById(id: string): Observable<IParkingLotItem> {
    return this.http.get(this.apiUrl + '/' + id);
  }

  updateParkingLotById(id: string, payload: IParkingLotItem): Observable<unknown> {
    return this.http.put(this.apiUrl + '/' + id, payload);
  }

  deleteParkingLot(id: string): Observable<unknown> {
    return this.http.delete(this.apiUrl + '/' + id);
  }
}
